import style from '../CSS/RoundVideoResult.module.css'

import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css'
import SliderItem from "./SliderItem";



const Slider = ({sliders}) => {
    return (
        <>
            <div className={style.slider}>
                <OwlCarousel className='owl-theme' items={6} autoplay loop margin={10} nav>
                    {
                        sliders.map((item)=>(
                            <div className='item'>
                                <SliderItem image={item.slider}/>
                            </div>
                        ))
                    }
                </OwlCarousel>
            </div>
        </>
    );
};

export default Slider;